import { render } from "./BusinessInvoice_profit_loss.vue?vue&type=template&id=077b01e9&scoped=true"
import script from "./BusinessInvoice_profit_loss.vue?vue&type=script&lang=js"
export * from "./BusinessInvoice_profit_loss.vue?vue&type=script&lang=js"

import "./BusinessInvoice_profit_loss.vue?vue&type=style&index=0&id=077b01e9&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-077b01e9"]])

export default __exports__